/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@keyframes spin{from{transform:rotate(0)}to{transform:rotate(359deg)}}@-webkit-keyframes spin{from{transform:rotate(0)}to{transform:rotate(359deg)}}.spacer[_ngcontent-%COMP%]{flex:1 1 auto}.mat-toolbar-row[_ngcontent-%COMP%]{height:80px!important}.profile-picture[_ngcontent-%COMP%]{margin-right:10px;border:1px solid #d3d3d3;border-radius:25px;padding:5px;height:23px;width:23px}.mat-toolbar[_ngcontent-%COMP%]{position:fixed;top:0;z-index:999;width:100%}"];
export { styles as styles };
